export default __webpack_public_path__ + "static/media/steps__slider-main-item-icon-1.39e1e6c3.svg";